<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :title="title"
      append-to-body
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <!-- @submit="(form,done,loading)=>applyFormAction(1,form,done,loading)" -->
      <avue-form
        :option="option"
        v-model="form"
        v-if="dialogVisible"
        ref="form"
      >
        <!-- <template slot="applyUserId" slot-scope="scope">
                <avue-input-tree 
                    default-expand-all 
                    v-model="form.applyUserId" 
                    placeholder="请选择申请人" 
                    type="tree" 
                    :dic="userlist"
                    @change="applyUserIdChange"
                >
                </avue-input-tree>
            </template> -->
        <template slot="projectId">
          <el-select
            v-model="form.projectId"
            :disabled="disabled"
            @change="projectIdChange"
          >
            <el-option
              v-for="item in projectIdList"
              :key="item"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="originWarehouseId">
          <el-select v-model="form.originWarehouseId" :disabled="disabled">
            <el-option
              v-for="item in warehouseList"
              :key="item"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="destWarehouseId">
          <el-select
            v-model="form.destWarehouseId"
            :disabled="disabled"
            @change="destWarehouseIdChange"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item"
              :value="item.id"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="applyUserId">
          <avue-input-tree v-model="form.applyUserId" :dic="userlist">
          </avue-input-tree>
        </template>
        <template slot="menuForm">
          <el-button
            v-if="editable"
            :loading="loading"
            @click="applyFormAction(2)"
            type="primary"
          >
            提交
          </el-button>
          <el-button
            v-if="!editable && auditBtn"
            @click="openAduitDialog"
            type="primary"
          >
            审核
          </el-button>
          <el-button v-if="!editable && printBtn" @click="print">
            打印
          </el-button>
          <el-button :loading="loading" @click="applyFormAction(3)">
            取消
          </el-button>
        </template>
        <template slot="dataList">
          <div>
            <ConsumableSelector
              :showSum="true"
              ref="cs"
              :columns="csColumns"
              :numberMode="numberMode"
              :numberKey="csNumKey"
              :priceKey="csPriceKey"
              :data.sync="csData"
              :projectId="this.form.projectId"
              @loadData="loadData"
              :priceMode="priceMode"
              @loadPrice="loadPrice"
              :editable="editable"
              @afterAdd="csDataAfterAdd"
              :scene="'out'"
            />
          </div>
        </template>
      </avue-form>

      <div style="display: flex; justify-content: center; margin-top: 30px">
        <el-button v-if="editable" type="primary" @click="applyFormAction(1)">
          保存
        </el-button>
        <el-button
          v-if="editable"
          :loading="loading"
          @click="applyFormAction(2)"
          type="primary"
        >
          提交
        </el-button>
        <el-button
          v-if="!editable && auditBtn"
          @click="openAduitDialog"
          type="primary"
        >
          审核
        </el-button>

        <el-button v-if="isCloseBtn" @click="openCloseDialog"> 关闭 </el-button>

        <el-button v-if="!editable && printBtn" @click="print">
          打印
        </el-button>
        <el-button v-if="isOutBound" type="primary" @click="outBound">
          出库
        </el-button>
        <el-button :loading="loading" @click="applyFormAction(3)">
          取消
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="closeDialog"
      width="40%"
      title="关闭调拨"
      append-to-body
      :close-on-click-modal="false"
      v-loading="closeLoading"
    >
      <el-row>
        <el-col>
          <el-form ref="closeForm" :model="closeForm" label-width="80px">
            <el-form-item
              label="关闭事由"
              required
              prop="remark"
              :rules="[
                { required: true, message: '请填写关闭事由', trigger: 'blur' },
                {
                  required: true,
                  message: '请填写关闭事由',
                  trigger: 'change',
                },
              ]"
            >
              <el-input
                placeholder="请输入关闭事由"
                type="textarea"
                maxlength="300"
                show-word-limit
                rows="5"
                v-model="closeForm.remark"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div style="display: flex; justify-content: center">
        <el-button type="primary" @click="closeOrder"> 确定 </el-button>
        <el-button @click="closeDialog = false"> 取消 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="aduitDialog"
      width="40%"
      title="审核"
      append-to-body
      :close-on-click-modal="false"
      v-loading="aduitloading"
    >
      <el-row>
        <el-col>
          <el-form ref="aduitform" :model="aduitform" label-width="80px">
            <el-form-item label="审核备注" prop="approveOpinion">
              <el-input
                placeholder="请输入备注信息"
                type="textarea"
                maxlength="300"
                show-word-limit
                rows="5"
                v-model="aduitform.approveOpinion"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div style="display: flex; justify-content: center">
        <el-button type="primary" @click="aduit(3)"> 通过 </el-button>
        <el-button @click="aduit(4)"> 驳回 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import formOption from "./from-option";
import ConsumableSelector from "@/components/consumable-selector/index";
import {
  closeOrderAction,
  allotOutboundSubmit,
  getDetail,
  getDegetConsumableListByRequisitionIdtail,
  getUserlist,
  consumableList,
  applyFormDetail,
  aduit,
  saveFormDetail,
  consumableCalculate,
} from "@/api/warehouse-allot/warehouse-allot";
import {
  viewUpdateConsumableList,
  getWarehouseListApply, //获取仓库下拉列表
  getAllWarehouseListApply,
  treeDeptsByIds, //当前登录人获取科室
} from "@/api/warehouseRequisition/warehouserequisition";
import {
  getProjectList,
  getWarehouseList,
  getDict,
  //   consumableList,
  getBusinessNo,
} from "@/api/crmedical/warehouse/index.js";
import { treeByProjectDeptId } from "@/api/crmedical/group/group";
import { mapGetters } from "vuex";
export default {
  components: {
    ConsumableSelector,
  },
  data() {
    return {
      isCloseBtn: false,
      isOutBound: false,
      title: "",

      auditBtn: false,
      printBtn: false,
      numberMode: "input",
      priceMode: "normal",
      aduitform: {
        approveOpinion: "",
      },
      closeForm: {
        remark: "",
      },
      aduitloading: false, //审核表单提交状态样式
      aduitDialog: false, //审核弹窗
      closeLoading: false, //审核表单提交状态样式
      closeDialog: false, //审核弹窗
      deptList: [],
      disabled: false,
      loading: false,
      option: formOption,
      dialogVisible: false,
      csData: [],
      csNumKey: "outboundNum",
      csColumns: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "分类", prop: "typeName" },
        { label: "单位", prop: "measuringUnitName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "出库单价", prop: "price" },
        { label: "调拨数量", prop: "allotNum" },
        { label: "库存数量", prop: "stockNum" },
        { label: "已出库数量", prop: "outNum" },
        {
          label: "出库数量",
          prop: "outboundNum",
          maxCheck: true,
        },
        { label: "小计", prop: "rowSum" },
        {
          label: "可出库数量",
          prop: "surplus",
          maxCheck: true,
          hide: true,
        },
      ],
      csColumnsView: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "类型", prop: "typeName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "计量单位", prop: "measuringUnitName" },
        { label: "库存数量", prop: "stockNum" },
        { label: "库存单价", prop: "price" },
        {
          label: "调拨数量",
          prop: "allotNum",
        },
      ],
      csColumnsOut: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "分类", prop: "typeName" },
        { label: "单位", prop: "measuringUnitName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "出库单价", prop: "price" },
        { label: "调拨数量", prop: "allotNum" },
        { label: "库存数量", prop: "stockNum", maxCheck: true },
        { label: "已出库数量", prop: "outNum" },
        { label: "出库数量", prop: "outboundNum" },
        { label: "小计", prop: "rowSum" },
        {
          label: "可出库数量",
          prop: "surplus",
          maxCheck: true,
          hide: true,
        },
      ],
      pageLoading: false,
      prjectList: [],
      userlist: [],
      warehouseList: [],
      warehouseInboundTypeList: [],
      inboundStatusList: [],
      dicts: {},
      editable: "add",
      form: {
        projectId: "",
        warehouseId: "",
        destWarehouseId: "",
        originWarehouseId: "",
        type: "",
        inboundStatus: "",
        allotNo: "",
        linkNo: "",
        id: "",
      },
      addDialogVisible: false,
      data: [], //入库单列表
      csData: [],
      submitFlag: true,
      mode: "",
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    // 'form.projectId'(val,oldval){
    //         if(!this.form.projectId){
    //                 return;
    //         }
    //         // this.csData = [];
    //         this.getWarehouseList();
    //         console.log();
    // },
    // 'form.warehouseId'(val,oldval){
    //         if(this.title == '查看'){
    //                 return;
    //         }
    //         if(val){
    //                 this.viewUpdateConsumableList(this.csData);
    //         }
    // },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    projectIdChange(val) {
      if (!this.form.projectId) {
        return;
      }
      this.form.originWarehouseId = "";
      this.form.destWarehouseId = "";
      this.csData = [];
      this.userlist = [];
      this.getWarehouseList();
    },
    destWarehouseIdChange(val) {
      getUserlist({ warehouseId: this.form.originWarehouseId }).then((res) => {
        // this.userlist = res.data;
        // let requisitionUsercolumn  = this.findObject(this.option.column, "applyUserId");
        // requisitionUsercolumn.dicData = this.userlist;
        // console.log(55655555)
        this.form = Object.assign({}, this.form, { applyUserId: "" });
        let arr = [];
        res.data.forEach((ele, index) => {
          arr.push({
            label: ele.keeperName,
            value: ele.userId,
          });
        });
        this.userlist = arr;
        console.log(this.userlist);
        // let requisitionUsercolumn  = this.findObject(this.option.column, "applyUserId");
        // requisitionUsercolumn.dicData = this.userlist;
      });
    },
    // 根据当前登录人获取科室
    treeDeptsByIds() {
      treeDeptsByIds().then((res) => {
        this.deptList = res.data;
        if (this.title == "申请") {
          this.form.requisitionDept = this.deptList[0]
            ? this.deptList[0].id
            : "";
        }
      });
    },
    // 获评变动后回调
    csDataAfterAdd(data, all) {
      this.viewUpdateConsumableList(all);
    },
    // 查询单价
    viewUpdateConsumableList(all) {
      let params = {
        warehouseId: this.form.warehouseId,
        inboundConsumableList: all || this.csData,
      };
      viewUpdateConsumableList(params).then((res) => {
        this.csData.forEach((ele, index) => {
          ele.price = res.data[index].stockPrice;
          ele.stockNum = res.data[index].stockNum;
        });
        this.$refs.cs.calcSums();
        // this.csData = res.data;
      });
    },
    // 打开审核弹窗
    openAduitDialog() {
      this.aduitDialog = true;
    },
    // 打开关闭弹窗
    openCloseDialog() {
      this.closeForm = { id: this.form.id };
      this.closeDialog = true;
    },

    // 关闭调拨单
    closeOrder(status) {
      // this.closeForm.id = this.
      this.$refs.closeForm.validate((valid) => {
        if (valid) {
          closeOrderAction(this.closeForm).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.closeForm.remark = "";
            this.closeDialog = false;
            this.dialogVisible = false;
            this.$emit("onLoad");
          });
        } else {
        }
      });
    },
    // 审核
    aduit(status) {
      this.aduitform.allotWorkStatus = status;
      this.$refs.aduitform.validate((valid) => {
        if (valid) {
          aduit(this.aduitform).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.aduitform.approveOpinion = "";
            this.aduitDialog = false;
            this.dialogVisible = false;
            this.$emit("onLoad");
          });
        } else {
        }
      });
    },
    // 打印
    print() {
      this.$message({
        message: "该功能暂未开放",
        type: "warning",
      });
    },
    // 打开弹窗页面
    openDialog(data) {
      this.isCloseBtn = false;
      let allotWorkStatus = data.data.allotWorkStatus;
      this.isCloseBtn = [2, 3, 5].includes(allotWorkStatus);
      this.isOutBound = false;
      this.treeDeptsByIds();
      this.form = {
        warehouseId: "",
        projectId: "",
        id: "",
      };
      this.submitFlag = true;
      this.csData = [];
      let projeCtcolumn = this.findObject(this.option.column, "projectId");
      projeCtcolumn.dicData = data.dicData.projectIdDictDataList;
      this.projectIdList = data.dicData.projectIdDictDataList;

      // userlist
      let applyUserIdcolumn = this.findObject(
        this.option.column,
        "applyUserId"
      );
      applyUserIdcolumn.dicData = data.dicData.userlist;
      data.dicData.userlist.forEach((item) => {
        item.label = item.label;
        item.value = item.value;
      });
      this.userlist = data.dicData.userlist;
      console.log("this.userlist====>", this.userlist);
      this.option.submitBtn = true;
      this.auditBtn = false;
      this.disabled = false;
      console.log("data.type=====>", data.type);

      if (data.type == "out") {
        this.form = {};
        this.csNumKey = "outboundNum";
        this.csColumns = this.csColumnsOut;
        this.priceMode = "dynamic";
        // userlist
        let applyTimecolumn = this.findObject(this.option.column, "applyTime");
        applyTimecolumn.display = true;
        this.isOutBound = true;
        this.option.submitBtn = false;
        this.option.column[0].disabled = true;
        this.option.column[3].disabled = true;
        this.title = "办理出库";
        this.numberMode = "input";
        this.editable = false;
        this.printBtn = false;
        this.mode = "first";
        this.disabled = true;
        this.aduitform.id = data.data.id;
        this.getDetail(data.data.id, (detail) => {
          this.form = detail;
          this.form.projectId = detail.projectId;
          this.form.requisitionDept = detail.requisitionDept;
          this.form.applyUserId = detail.applyUserId;
          this.form.remark = detail.remark;
          this.form.allotNo = detail.allotNo;
          console.log(
            "(detail.allotWorkStatus==2 && data.auditBtn)=====>",
            detail.allotWorkStatus == 2 && data.auditBtn
          );
          if (detail.allotWorkStatus == 2 && data.auditBtn) {
            this.auditBtn = true;
          }
          if (
            detail.allotWorkStatus == 3 ||
            detail.allotWorkStatus == 4 ||
            detail.allotWorkStatus == 5 ||
            detail.allotWorkStatus == 6 ||
            detail.allotWorkStatus == 7 ||
            detail.allotWorkStatus == 8
          ) {
            this.printBtn = true;
          }
          console.log("detail.consumableList========>", detail.consumableList);
          detail.consumableList.forEach((ele) => {
            ele.outboundNum = "";
            ele.surplus = ele.allotNum - ele.outNum;
          });
          this.csData = detail.consumableList;

          if (detail.allotWorkStatus == 3) {
            this.isOutBound = true;
          }
          this.getWarehouseList();
          this.dialogVisible = true;
        });
        // this.getDegetConsumableListByRequisitionIdtail(data.data.id);
        this.option.disabled = false;
      }
      if (data.type == "view") {
        this.form = {};
        // userlist
        this.csNumKey = "allotNum";
        this.csColumns = this.csColumnsView;
        let applyTimecolumn = this.findObject(this.option.column, "applyTime");
        applyTimecolumn.display = true;

        this.option.submitBtn = false;
        this.title = "查看";
        this.numberMode = "mormal";
        this.editable = false;
        this.printBtn = false;
        this.mode = "first";
        this.disabled = true;
        this.aduitform.id = data.data.id;
        this.closeForm.id = data.data.id;
        this.getDetail(data.data.id, (detail) => {
          this.form = detail;
          this.form.projectId = detail.projectId;
          this.form.requisitionDept = detail.requisitionDept;
          this.form.applyUserId = detail.applyUserId;
          this.form.remark = detail.description;
          this.form.allotNo = detail.allotNo;
          console.log(
            "(detail.allotWorkStatus==2 && data.auditBtn)=====>",
            detail.allotWorkStatus == 2 && data.auditBtn
          );
          if (detail.allotWorkStatus == 2 && data.auditBtn) {
            this.auditBtn = true;
          }
          if (
            detail.allotWorkStatus == 3 ||
            detail.allotWorkStatus == 5 ||
            detail.allotWorkStatus == 6 ||
            detail.allotWorkStatus == 7 ||
            detail.allotWorkStatus == 8
          ) {
            this.printBtn = true;
          }
          console.log("warehouseList=====>", this.warehouseList);
          console.log("form.destWarehouseId=====>", this.form.destWarehouseId);
          this.form = Object.assign({}, this.form, {
            destWarehouseId: detail.destWarehouseId,
          });
          console.log("detail.consumableList========>", detail.consumableList);
          this.getWarehouseList();
          this.csData = detail.consumableList;
          this.dialogVisible = true;
        });

        // this.getDegetConsumableListByRequisitionIdtail(data.data.id);
        this.option.disabled = true;
      }
      if (data.type == "edit") {
        this.form = {};
        this.csNumKey = "allotNum";
        this.title = "编辑";
        this.numberMode = "input";
        this.editable = true;
        this.mode = "first";
        this.aduitform.id = data.data.id;
        this.getDetail(data.data.id, (detail) => {
          this.form = detail;
          this.form.projectId = detail.projectId;
          this.form.requisitionDept = detail.requisitionDept;
          this.form.applyUserId = detail.applyUserId;
          this.form.remark = detail.remark;
          this.form.requisitionNo = detail.requisitionNo;
          console.log("detail.consumableList========>", detail.consumableList);
          this.csData = detail.consumableList;
          this.dialogVisible = true;
        });

        // this.getDegetConsumableListByRequisitionIdtail(data.data.id);
        this.option.disabled = false;
        // this.dialogVisible = true;
      }
    },
    getDetail(id, callback) {
      getDetail({ id: id }).then((res) => {
        callback(res.data);
      });
    },
    formError(done) {
      done();
    },
    async outBound() {
      let validateResult = this.$refs.cs.validate();
      if (!validateResult) {
        console.log(validateResult);
        return;
      }
      let flag = true;
      this.csData.forEach((ele) => {
        let a = Number(ele.outboundNum);
        if (ele.outboundNum == "" || Number(ele.outboundNum) < 1) {
          flag = false;
        }
      });
      if (!flag) {
        this.$message({
          message: "请输入正确的出库数量",
          type: "warning",
        });
        return;
      }
      console.log(this.form);
      let outBoundForm = {};
      let no = await getBusinessNo({ businessType: 2 });
      outBoundForm.outboundNo = no.data;
      outBoundForm.linkNo = this.form.allotNo;
      let arr = [];
      this.csData.forEach((ele) => {
        arr.push({
          outboundNum: ele.outboundNum,
          consumableId: ele.consumableId,
        });
      });
      outBoundForm.consumableList = arr;
      outBoundForm.remark = this.form.remark;
      outBoundForm.projectId = this.form.projectId;
      outBoundForm.warehouseId = this.form.originWarehouseId;
      console.log(outBoundForm);
      this.outBoundSubmit(outBoundForm);
      console.log(66666);
    },
    outBoundSubmit(outBoundForm) {
      allotOutboundSubmit(outBoundForm).then((res) => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.$emit("onLoad");
      });
    },
    // 保存 提交
    async applyFormAction(type, form, done, loading) {
      console.log(type, form, done);
      if (done) {
        done();
      }

      console.log("form=====>", form);
      if (type == 3) {
        this.dialogVisible = false;
        this.$emit("onLoad");
        return;
      }
      let validateResult = this.$refs.cs.validate();
      if (!validateResult) {
        console.log(validateResult);
        return;
      }

      let flag = true;
      this.csData.forEach((ele) => {
        let a = Number(ele.allotNum);
        if (ele.allotNum == "" || Number(ele.allotNum) < 1) {
          flag = false;
        }
      });

      if (this.form.destWarehouseId && this.form.originWarehouseId) {
        if (this.form.destWarehouseId === this.form.originWarehouseId) {
          this.$message({
            message: "调入仓库和调出仓库不能相同！",
            type: "warning",
          });
          return;
        }
      }

      if (!flag) {
        this.$message({
          message: "请输入正确的调拨数量",
          type: "warning",
        });
        return;
      }
      if (this.csData.length < 1 && type != 3) {
        if (type == 1) {
          this.$message({
            message: "请选择申请物品后再保存",
            type: "warning",
          });
        } else {
          this.$message({
            message: "请选择申请物品后再提交",
            type: "warning",
          });
        }

        return;
      }
      // this.$refs.form.validate((valid) => {});

      let valid_ = true;
      await this.$refs.form.validate((valid, done, msg) => {
        valid_ = valid;
        done();
      });
      if (!valid_) {
        return;
      }
      if (valid_) {
        this.form.allotWorkStatus = type;

        this.form.requisitionTime = this.dayjs(
          this.form.requisitionTime
        ).format("YYYY-MM-DD HH:mm:ss");
        if (!this.submitFlag) {
          return;
        }
        this.submitFlag = false;
        this.loading = true;
        this.form.consumableList = [];
        this.csData.forEach((ele) => {
          let temObj = {
            consumableId: ele.consumableId,
            allotNum: ele.allotNum,
            price: ele.price,
          };
          this.form.consumableList.push(temObj);
        });
        if (type == 2) {
          applyFormDetail(this.form)
            .then((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.form.id = res.data.id;
              this.submitFlag = true;
              this.loading = false;
              // if(type==1){
              //         this.$message({
              //                 message: '保存成功',
              //                 type: 'success'
              //         });
              //         this.$refs.crud.toggleSelection();
              //         this.option.disabled = false;
              // }else{
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.$emit("onLoad");
              // }
            })
            .catch((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.submitFlag = true;
              this.loading = false;
            });
        }

        if (type == 1) {
          saveFormDetail(this.form)
            .then((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.form.id = res.data.id;
              this.submitFlag = true;
              this.loading = false;
              // if(type==1){
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$refs.crud.toggleSelection();
              this.option.disabled = false;
              // }else{
              //         this.$message({
              //                 message: '提交成功',
              //                 type: 'success'
              //         });
              //         this.dialogVisible = false;
              //         this.$emit('onLoad');
              // }
            })
            .catch((res) => {
              if (done) {
                console.log("err==================>", loading);
                done();
              }
              this.submitFlag = true;
              this.loading = false;
            });
        }
      } else {
        return false;
      }
      if (done) {
        done();
      }
    },
    // 根据id获取材料清单
    getDegetConsumableListByRequisitionIdtail(id) {
      getDegetConsumableListByRequisitionIdtail({ requisitionId: id }).then(
        (res) => {
          res.data.forEach((ele) => {
            ele.rowSum = ele.inboundNum * ele.price;
            ele.rowSum = ele.rowSum.toFixed(2);
          });
          this.csData = res.data;
          this.dialogVisible = true;
          setTimeout(() => {
            console.log("this.$refs.form========>", this.$refs.form);
          });
        }
      );
    },
    // 获取仓库列表 科室列表
    getWarehouseList() {
      if (this.mode == "first") {
      } else {
        this.form.warehouseId = "";
      }
      this.warehouseList = [];
      getAllWarehouseListApply({ projectId: this.form.projectId }).then(
        (res) => {
          this.warehouseList = res.data;

          if (this.mode != "first") {
            this.form.warehouseId = this.warehouseList[0]
              ? this.warehouseList[0].id
              : "";
          }
        }
      );
    },

    loadData(query, resolve) {
      query.name = query.text;
      const params = {
        ...query,
        projectId: this.form.projectId,
        warehouseId: this.form.originWarehouseId,
      };
      const columns = [
        { label: "分类", prop: "typeName" },
        { label: "编号", prop: "code" },
        { label: "名称", prop: "name" },
        { label: "计量单位", prop: "measuringUnitName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
      ];
      consumableList(params).then((res) => {
        res.data.records.forEach((element) => {
          element.id = "";
        });
        resolve(res.data, columns);
      });
    },
    loadPrice(query, resolve) {
      const params = {
        ...query,
        warehouseId: this.form.originWarehouseId,
      };
      consumableCalculate(params).then((res) => {
        console.log("res consumableCalculate==>", res);
        resolve(res.data);
      });
      // setTimeout(() => {
      //         resolve(10.0);
      // }, 500);
    },
    async fetchData() {
      this.pageLoading = true;
      try {
        //projectList
        const resProjectList = await getProjectList();
        this.prjectList = resProjectList.data;
        this.form.projectId = this.prjectList[0] ? this.prjectList[0].id : "";
        //warehouseList
        // const resWarehouseList = await getWarehouseList({
        // projectId: this.form.projectId,
        // });
        // this.warehouseList = resWarehouseList.data;

        // this.form.warehouseId = this.warehouseList[0]
        // ? this.warehouseList[0].id
        // : "";
        //type && status
        const dicts = await Promise.all([
          getDict({ code: "warehouse_inbound_type" }),
          getDict({ code: "inbound_status" }),
        ]);
        this.warehouseInboundTypeList = dicts[0].data;
        this.form.type = this.warehouseInboundTypeList[0].dictKey;
        this.inboundStatusList = dicts[1].data;
        this.form.inboundStatus = this.inboundStatusList[0].dictKey;
        //load list
        // this.loadList();
      } catch (err) {}
      this.pageLoading = false;
    },
  },
};
</script>
